var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "input-split list-unstyled" },
    _vm._l(_vm.sortedSplit, function(item) {
      return _c(
        "li",
        {
          key: item.share.id,
          class: { removed: item.removed },
          attrs: { title: item.title }
        },
        [
          _vm.showCheckbox
            ? _c("div", { staticClass: "form-check" }, [
                _c("label", { staticClass: "form-check-label" }, [
                  _c("input", {
                    staticClass: "form-check-input",
                    attrs: {
                      type: "checkbox",
                      checked: "checked",
                      disabled: _vm.disabled
                    },
                    domProps: { checked: item.share.value },
                    on: {
                      change: function($event) {
                        _vm.toggleSplit($event, item.share)
                      }
                    }
                  }),
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.sheet.getBooker(item.share.id).name) +
                      "\n\t\t\t"
                  )
                ])
              ])
            : _c("div", { staticClass: "text-right" }, [
                _vm._v(_vm._s(_vm.sheet.getBooker(item.share.id).name))
              ]),
          _vm._v(" "),
          _c("span", [_vm._v("×")]),
          _vm._v(" "),
          _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: item.share.value,
                  expression: "item.share.value",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "number",
                step: "0.1",
                min: "0",
                required: "",
                disabled: _vm.disabled
              },
              domProps: { value: item.share.value },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(item.share, "value", _vm._n($event.target.value))
                },
                blur: function($event) {
                  _vm.$forceUpdate()
                }
              }
            })
          ])
        ]
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70940068", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70940068","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/ui/widgets/input-split.vue
// module id = JHpk
// module chunks = 3